import { render, staticRenderFns } from "./sweet-button.vue?vue&type=template&id=ee4bfc1e"
import script from "./sweet-button.vue?vue&type=script&lang=js"
export * from "./sweet-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports